const Example = () => {
    return <h1>Example</h1>
};

export default Example;